import { useEffect, useState } from 'react'
import styled from 'styled-components'

import { Button, Field, Layout, Text } from '@loadsmart/miranda-react'
import { toCSSValue } from '@loadsmart/miranda-react/dist/tokens'

const HourItem = styled(Button)<{ $selected: boolean }>`
  width: 144px;

  background-color: ${({ $selected }) =>
    $selected ? toCSSValue('color-neutral-20') : 'transparent'};
  color: ${({ $selected }) =>
    $selected ? toCSSValue('color-text-primary') : toCSSValue('color-primary-100')};
`

function selectedIndexInitializer(timeSlots: string[] | undefined, value: string | null) {
  if (timeSlots && value) {
    const index = timeSlots?.indexOf(value) ?? -1
    return index !== -1 ? index : null
  }
  return null
}

export function ScheduleTimeList({
  timeSlots,
  setValue,
  validationStatus,
  errorMessage,
  value,
}: {
  timeSlots: string[] | undefined
  setValue: (value: string | null) => void
  validationStatus: 'danger' | 'default'
  errorMessage: string | undefined
  value: string | null
}) {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(() =>
    selectedIndexInitializer(timeSlots, value)
  )

  useEffect(() => {
    if (timeSlots && value) {
      const index = timeSlots?.indexOf(value) ?? -1
      setSelectedIndex(index)
    }
  }, [value, timeSlots])

  if (timeSlots) {
    return (
      <Layout.Stack gap="spacing-2">
        <Field required status={validationStatus}>
          <Field.Label>Hour</Field.Label>
          <Layout.Stack
            align="center"
            paddingT="spacing-1"
            paddingB="spacing-1"
            style={{ maxHeight: '140px', overflowY: 'auto' }}
            gap="spacing-2"
          >
            {timeSlots.map((timeSlot, index) => {
              return (
                <HourItem
                  $selected={selectedIndex === index}
                  onClick={() => {
                    if (selectedIndex === index) {
                      setSelectedIndex(null)
                      setValue(null)
                      return
                    }

                    setSelectedIndex(index)
                    setValue(timeSlot)
                  }}
                  variant="secondary"
                >
                  {timeSlot}
                </HourItem>
              )
            })}
          </Layout.Stack>
          {validationStatus === 'danger' && <Field.Hint>{errorMessage}</Field.Hint>}
        </Field>
      </Layout.Stack>
    )
  }

  return (
    <Layout.Stack gap="spacing-6">
      <Field required>
        <Field.Label>Hour</Field.Label>
      </Field>
      <Layout.Stack gap="spacing-2" align="center">
        <Text variant="heading-sm-bold" color="color-text-primary">
          No availability
        </Text>
        <Text variant="body-md" color="color-text-secondary" style={{ textAlign: 'center' }}>
          Please select another Load type that may fit or
          <br /> another date.
        </Text>
      </Layout.Stack>
    </Layout.Stack>
  )
}
